import { ButtonComponent } from '@/components/commons'
import { Text } from '@/components/commons/typography/Text'
import { Title } from '@/components/commons/typography/Title'
import { Modal } from '@/components/modal/Modal'

interface HighlightDeleteModalProps {
  opened: boolean
  isLoading?: boolean
  useRemoveOnProject?: boolean
  onConfirm: () => void
  close: () => void
}

export const HighlightDeleteModal = ({
  opened,
  close,
  useRemoveOnProject,
  onConfirm,
  isLoading,
}: HighlightDeleteModalProps) => {
  const title = useRemoveOnProject ? 'Remove Highlight' : 'Delete Highlight'
  const message = useRemoveOnProject
    ? 'Are you sure you want to remove this Highlight from this Project?'
    : 'Are you sure you want to delete this Highlight?'
  const confirmLabel = useRemoveOnProject ? 'Remove' : 'Delete'

  return (
    <Modal
      opened={opened}
      onClose={close}
      withCloseButton={false}
      className="--v2"
    >
      <div className="p-20 rounded-12">
        <Title className="text-center">{title}</Title>
        <Text className="text-center mt-16">{message}</Text>

        <div className="pt-24 flex gap-12 items-center justify-center">
          <ButtonComponent
            variation="secondary"
            size="xSmall"
            label="Cancel"
            onClick={close}
            loading={isLoading}
          />
          <ButtonComponent
            variation="danger"
            size="xSmall"
            label={confirmLabel}
            onClick={onConfirm}
            loading={isLoading}
          />
        </div>
      </div>
    </Modal>
  )
}
